import { render, staticRenderFns } from "./InvestCoverageFormulaValidation.vue?vue&type=template&id=4026897c&scoped=true"
import script from "./InvestCoverageFormulaValidation.vue?vue&type=script&lang=js"
export * from "./InvestCoverageFormulaValidation.vue?vue&type=script&lang=js"
import style0 from "./InvestCoverageFormulaValidation.vue?vue&type=style&index=0&id=4026897c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4026897c",
  null
  
)

export default component.exports